import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
// Copyright 1999-2019. Plesk International GmbH. All rights reserved.
import { isRtl } from '../../utils';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { CLS_PREFIX } from '../../constants';
import Button from '../Button';
import Icon from '../Icon';

var Header =
/*#__PURE__*/
function (_Component) {
  _inherits(Header, _Component);

  function Header() {
    _classCallCheck(this, Header);

    return _possibleConstructorReturn(this, _getPrototypeOf(Header).apply(this, arguments));
  }

  _createClass(Header, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.isRtl = isRtl();
    }
  }, {
    key: "renderBackButton",
    value: function renderBackButton() {
      var _this$props = this.props,
          baseClassName = _this$props.baseClassName,
          onClose = _this$props.onClose;
      return React.createElement(Button, {
        ghost: true,
        className: "".concat(baseClassName, "__back-button"),
        icon: React.createElement(Icon, {
          name: "chevron-left",
          flipHorizontal: this.isRtl,
          className: "".concat(baseClassName, "__icon")
        }),
        onClick: onClose
      });
    }
  }, {
    key: "renderHideButton",
    value: function renderHideButton() {
      var _this$props2 = this.props,
          baseClassName = _this$props2.baseClassName,
          onClose = _this$props2.onClose;
      return React.createElement(Button, {
        ghost: true,
        className: "".concat(baseClassName, "__button"),
        icon: React.createElement(Icon, {
          className: "".concat(baseClassName, "__icon"),
          name: "minimize"
        }),
        onClick: onClose
      });
    }
  }, {
    key: "renderCloseButton",
    value: function renderCloseButton() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref$disabled = _ref.disabled,
          disabled = _ref$disabled === void 0 ? false : _ref$disabled;

      var _this$props3 = this.props,
          baseClassName = _this$props3.baseClassName,
          onClose = _this$props3.onClose;
      return React.createElement(Button, {
        ghost: true,
        className: "".concat(baseClassName, "__button"),
        icon: React.createElement(Icon, {
          name: 'cross-mark',
          className: "".concat(baseClassName, "__icon")
        }),
        onClick: onClose,
        disabled: disabled
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          baseClassName = _this$props4.baseClassName,
          onClose = _this$props4.onClose,
          children = _this$props4.children,
          backButton = _this$props4.backButton,
          hideButton = _this$props4.hideButton,
          props = _objectWithoutProperties(_this$props4, ["baseClassName", "onClose", "children", "backButton", "hideButton"]);

      var prefix;
      var suffix;

      if (onClose) {
        switch (true) {
          case backButton:
            prefix = this.renderBackButton();
            break;

          case hideButton:
            suffix = React.createElement(React.Fragment, null, this.renderHideButton(), this.renderCloseButton({
              disabled: true
            }));
            break;

          default:
            suffix = this.renderCloseButton();
            break;
        }
      }

      return React.createElement("div", _extends({
        className: baseClassName
      }, props), prefix, React.createElement("h4", {
        className: "".concat(baseClassName, "__title")
      }, children), suffix);
    }
  }]);

  return Header;
}(Component);

_defineProperty(Header, "propTypes", {
  baseClassName: PropTypes.string,
  onClose: PropTypes.func,
  children: PropTypes.node.isRequired,
  backButton: PropTypes.bool,
  hideButton: PropTypes.bool
});

_defineProperty(Header, "defaultProps", {
  onClose: null,
  baseClassName: "".concat(CLS_PREFIX, "drawer-header"),
  backButton: false,
  hideButton: false
});

export { Header as default };